import { DeviceStatus } from "@oneleet/api_client";
import { getReadableText } from "@oneleet/utils";

import { VariantProps, cva } from "class-variance-authority";

const statusIndicatorVariants = cva("size-4 shrink-0", {
  variants: {
    status: {
      [DeviceStatus.NON_COMPLIANT]: "stroke-ng-red-900 fill-ng-red-800",
      [DeviceStatus.COMPLIANT]: "stroke-ng-green-900 fill-ng-green-800",
      [DeviceStatus.PENDING]: "stroke-accent-900 fill-accent-400",
      [DeviceStatus.UNASSIGNED]: "fill-neutral-50 stroke-neutral-400",
      [DeviceStatus.OUT_OF_SCOPE]: "fill-neutral-50 stroke-neutral-400",
      [DeviceStatus.ARCHIVED]: "stroke-neutral-450 fill-neutral-300",
    },
  },
});

export type DeviceStatusIndicatorProps = VariantProps<
  typeof statusIndicatorVariants
>;

export const DeviceStatusIndicator = ({
  status,
}: DeviceStatusIndicatorProps) => {
  if (!status)
    throw new Error(
      "No status prop was passed to DeviceStatusIndicator but is required",
    );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={statusIndicatorVariants({ status })}
      aria-label={getReadableText(status)}
    >
      <path
        d="M5.2 3.33333C5.2 3.11034 5.26798 2.92374 5.35289 2.81052C5.43491 2.70117 5.49608 2.7 5.5 2.7H10.5C10.5039 2.7 10.5651 2.70117 10.6471 2.81052C10.732 2.92374 10.8 3.11034 10.8 3.33333V12.6667C10.8 12.8897 10.732 13.0763 10.6471 13.1895C10.5651 13.2988 10.5039 13.3 10.5 13.3H5.5C5.49608 13.3 5.43491 13.2988 5.35289 13.1895C5.26798 13.0763 5.2 12.8897 5.2 12.6667V3.33333Z"
        strokeWidth="1.4"
      />
    </svg>
  );
};
